import PropTypes from "prop-types";
import { forwardRef, useEffect } from "react";
import { Link } from "react-router-dom";

// material-ui
import { useTheme } from "@mui/material/styles";
import {
  Chip,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Skeleton,
  Typography,
  useMediaQuery,
} from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
// import AssignmentIcon from '@mui/icons-material/Assignment';

// project imports

import useConfig from "hooks/useConfig";
import { useDispatch, useSelector } from "store";
import { activeItem, openDrawer } from "store/slices/menu";

import DashboardIcon from "assets/images/icons/dashboard-icon.svg";
import DashboardBlueIcon from "assets/images/icons/dashboard-blue-icon.svg";

// third-party
import { connect } from "react-redux";

import { useLocation } from "react-router-dom";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import BadgeIcon from "@mui/icons-material/Badge";

// ==============================|| SIDEBAR MENU LIST ITEMS ||============================== //

const NavItem = (props) => {
  // console.log(" props:", props)
  const { item, level } = props;
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down("lg"));

  const { borderRadius } = useConfig();
  const { openItem } = useSelector((state) => state.menu);

  let itemTarget = "_self";
  if (item.target) {
    itemTarget = "_blank";
  }

  let listItemProps = {
    component: forwardRef((props, ref) => (
      <Link ref={ref} {...props} to={item.url} target={itemTarget} />
    )),
  };
  if (item?.external) {
    listItemProps = { component: "a", href: item.url, target: itemTarget };
  }

  const itemHandler = (id) => {
    dispatch(activeItem([id]));
    if (matchesSM) dispatch(openDrawer(false));
  };

  // active menu item on page load
  // useEffect(() => {
  //   const currentIndex = document.location.pathname
  //     .toString()
  //     .split("/")
  //     .findIndex((id) => id === item.id);
  //   if (currentIndex > -1) {
  //     dispatch(activeItem([item.id]));
  //   }
  //   // eslint-disable-next-line
  // }, []);

  // Check if the item is active based on the current path
  const isActive = location.pathname === item.url;

  useEffect(() => {
    if (isActive) {
      dispatch(activeItem([item.id])); // Highlight the active item on render
    }
  }, [isActive, item.id, dispatch]);

  // useEffect(() => {
  //   const path = window.location.hash.split("#");
  //   if (item.url === path[1]) {
  //     dispatch(activeItem([item.id]));
  //   }
  // }, [dispatch, item]);

  return (
    <ListItemButton
      {...listItemProps}
      disabled={item.disabled}
      sx={{
        borderRadius: `${borderRadius}px`,
        mb: 0.5,
        alignItems: "center",
        // backgroundColor: level > 1 ? "transparent !important" : "inherit",
        backgroundColor: isActive
          ? theme.palette.action.selected
          : level > 1
          ? "transparent !important"
          : "inherit",

        py: level > 1 ? 1 : 1.25,
        pl: `${level * 24}px`,
      }}
      // selected={openItem?.findIndex((id) => id === item.id) > -1}
      selected={isActive}
      onClick={() => itemHandler(item.id)}
    >
      <ListItemIcon sx={{ my: "auto", minWidth: !item?.icon ? 18 : 36 }}>
        {item.id === "dashboard" && (
          <img
            src={
              openItem[0] === "dashboard" ? DashboardBlueIcon : DashboardIcon
            }
            alt={openItem[0]}
          />
        )}
        {item.id === "account_dashboard" && (
          <ManageAccountsIcon style={{ width: "18px" }} />
        )}
        {item.id === "portfolio_dashboard" && (
          <BadgeIcon style={{ width: "18px" }} />
        )}
        
      </ListItemIcon>
      <ListItemText
        primary={
          // <Typography  variant={ openItem?.findIndex((id) => id === item.id) > -1 ? "h5" : "body1"}
          <Typography variant={isActive ? "h5" : "body1"} color="inherit">
            {item.title}
          </Typography>
        }
        secondary={
          item.caption && (
            <Typography
              variant="caption"
              sx={{ ...theme.typography.subMenuCaption }}
              display="block"
              gutterBottom
            >
              {item.caption}
            </Typography>
          )
        }
      />
      {/* {item.chip && (
        leave_request_count_loading ? (
          <Skeleton variant="text" width={35} height={25} sx={{ marginLeft: theme.spacing(1), display: "inline-flex", alignItems: "center" }} />
        ) : (
          <Chip
            color={item.chip.color}
            variant={item.chip.variant}
            size={item.chip.size}
            label={leave_request_count && leave_request_count?.request_count ? leave_request_count?.request_count : 0}
            sx={{
              "& .MuiChip-label": { overflow: "unset !important" }
            }}
          />
        ))} */}
    </ListItemButton>
  );
};

NavItem.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number,
};

export default connect(null, {})(NavItem);
